import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { List } from '../../../components/List';
import { Card } from '../../../components/Card';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectWorks } from '../../Api/selectors';
import { deleteCompanyProperty, setCompanyProperty } from '../actions';
import { REQUEST_COMPANY_ADD_USER, REQUEST_COMPANY_DELETE_USER_FROM_COMPANY } from '../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Dropdown } from '../../../components/Dropdown';
import cn from 'classnames';

const STATE = {
  deleteUser: false,
  addUser: false,
  selectedUser: null,
  selectedRole: null,
};

const Container = styled.div`
  background-color: #fff;
  font-size: 14px;
  margin: 6px 0;
  padding: 0;
  width: 100%;

  .info {
    // width: 380px;
    background-color: white;
    padding: 12px;
  }

  .title-block {
    .title {
      text-transform: uppercase;
      font-size: 14px;
    }
  }
`;

const ROLES = ['relation_financial_contact_id', 'relation_commercial_contact_id', 'relation_vehicle_documents_contact_id'];
const ROLES_NAMES = ['Financial contact: ', 'Commercial contact: ', 'Vehicle documents contact: '];

/* eslint-disable react/prefer-stateless-function */
class CompanyRolesComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  getFullname = user => {
    if (!user || user === 'N/A') return 'N/A';
    const name = user?.properties?.find(p => p?.name?.name === 'name')?.value;
    const surname = user?.properties?.find(p => p?.name?.name === 'surname')?.value;
    return name && surname ? `${name} ${surname}` : user?.email_address ?? 'Unknown user';
  };

  renderRole = (role, roleName) => {
    const relation = this.props.company?.properties?.find(p => p?.name?.name === role);
    const user = relation?.value
      ? this.props.company?.users?.find(user => user?.id === parseInt(relation?.value, 10))
      : 'N/A';
    const userName = this.getFullname(user);
    return (
      <VBox vCenter flexWrap style={{ paddingTop: 12 }} key={roleName}>
        <div>
          <strong>{roleName}</strong>
        </div>
        <div>
          <span style={{ marginRight: 6 }}>{userName}</span>
          {userName !== 'N/A' ? (
            <FontAwesomeIcon
              icon={faTimes}
              color="red"
              style={{ cursor: 'pointer' }}
              onClick={() => this.handleReset(role)}
            />
          ) : (
            <FontAwesomeIcon
              icon={faPlus}
              color="green"
              style={{ cursor: 'pointer' }}
              onClick={() => this.handleSet(role)}
            />
          )}
        </div>
      </VBox>
    );
  };

  handleReset = role => {
    this.setState({ deleteUser: true, selectedRole: role });
    console.log(`Remove from role ${role}`);
  };

  handleSet = role => {
    this.setState({ addUser: true, selectedRole: role, selectedUser: null });
    console.log(`Add to role ${role}`);
  };

  render() {
    const { company } = this.props;
    if (!company) return null;
    return (
      <Container>
        <Card className={cn('company-info-card info', this.props.className)}>
          <HBox vCenter className="title-block">
            <h2 className="title">{this.lbl('company.details.contacts.relation')}</h2>
          </HBox>
          <List className="users-list">
            {ROLES_NAMES.map((relation, idx) => {
              return this.renderRole(ROLES[idx], relation);
            })}
          </List>
          {this.renderDeleteUser()}
          {this.renderAddUser()}
        </Card>
      </Container>
    );
  }

  handleChange = newUser => {
    this.setState({ selectedUser: newUser });
  };

  renderAddUser() {
    if (!this.state.addUser) return null;
    const userOptions = this.props.company?.users.map(user => ({
      label: user?.name?.name ?? user?.email_address,
      value: user?.id,
    }));
    return (
      <Modal title={this.lbl('company.users.delete.confirm.title')}>
        <Dropdown options={userOptions} value={this.state.selectedUser} onChange={this.handleChange} />
        <ModalControls>
          <Button
            disabled={!this.state.selectedUser}
            onClick={() => this.props.save(this.state.selectedRole, this.state.selectedUser?.value, this.reset.bind(this))}
          >
            {this.lbl('add')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderDeleteUser() {
    if (!this.state.deleteUser) return null;
    const propertyId = this.props.company?.properties?.find(p => p?.name?.name === this.state.selectedRole)?.id;
    return (
      <Modal title={this.lbl('company.users.delete.confirm.title')}>
        <span>Do you really want to delete user from role?</span>
        <ModalControls>
          <Button small primary onClick={() => this.props.deleteCompanyProperty(propertyId, this.reset.bind(this))}>
            {this.lbl('ok')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

CompanyRolesComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  company: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    works: selectWorks([REQUEST_COMPANY_DELETE_USER_FROM_COMPANY, REQUEST_COMPANY_ADD_USER]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    save(property_name, value, cb) {
      dispatch(setCompanyProperty(ownProps.company.id, property_name, value, cb));
    },
    deleteCompanyProperty(propertyId, callback) {
      dispatch(deleteCompanyProperty(propertyId, ownProps.company.id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyRoles = compose(withConnect, withRouter)(CompanyRolesComp);
